import { Activity } from '../activity/activity';
import { Competency } from '../competency/competency';

/**
 * イベント情報
 */
export class SurveyAnswer {
  type: number = 0;
  activityAnswers: SurveyActivityAnswer[] = [];
  competencyAnswers: SurveyCompetencyAnswer[] = [];
  selectActivities: SurveyCompetencySelectActivity[] = [];

  deserialize(input: any) {
    if (!input) return;
    this.type = input.type;
    this.activityAnswers = input.activityAnswers ? input.activityAnswers.map((s: SurveyActivityAnswer) => new SurveyActivityAnswer().deserialize(s)) : [];
    this.competencyAnswers = input.competencyAnswers ? input.competencyAnswers.map((s: SurveyCompetencyAnswer) => new SurveyCompetencyAnswer().deserialize(s)) : [];
    this.selectActivities = input.selectActivities ? input.selectActivities.map((s: SurveyCompetencySelectActivity) => new SurveyCompetencySelectActivity().deserialize(s)) : [];
    return this;
  }
}

export class UserSurveyWithActiveEntryMatrix {
  totalUser: number = 0;
  activities: Activity[] = [];
  competencies: Competency[] = [];
  metaAwarenessGrowthQuestions: MetaAwarenessGrowthQuestion[] = [];
  userSurveyAnalysis: SurveyAnswer[] = [];
  activeEntryMatrices: ActiveEntryMatrix[] = [];

  deserialize(input: any) {
    this.totalUser = input.totalUser;
    this.userSurveyAnalysis = input.userSurveyAnalysis ? input.userSurveyAnalysis.map((s: SurveyAnswer) => new SurveyAnswer().deserialize(s)) : [];
    this.activeEntryMatrices = input.activeEntryMatrices ? input.activeEntryMatrices.map((a: ActiveEntryMatrix) => new ActiveEntryMatrix().deserialize(a)) : [];
    this.activities = input.activities
      ? input.activities
          .map((a: Activity) => new Activity().deserialize(a))
          .sort(function (a: Activity, b: Activity) {
            return a.activityID - b.activityID;
          })
      : [];
    this.competencies = input.competencies
      ? input.competencies
          .map((c: Competency) => new Competency().deserialize(c))
          .sort(function (a: Competency, b: Competency) {
            return a.competencyID - b.competencyID;
          })
      : [];
    this.metaAwarenessGrowthQuestions = input.metaAwarenessGrowthQuestions
      ? input.metaAwarenessGrowthQuestions
          .map((m: MetaAwarenessGrowthQuestion) => new MetaAwarenessGrowthQuestion().deserialize(m))
          .sort(function (a: MetaAwarenessGrowthQuestion, b: MetaAwarenessGrowthQuestion) {
            return a.competencyID - b.competencyID;
          })
      : [];

    return this;
  }
}

/**
 * エンゲージメントを問う質問の回答
 */
export class SurveyActivityAnswer {
  ID: number;
  activityID: number;
  userID: number;
  score: number = 50;

  deserialize(input: any) {
    if (!input) return this;
    this.ID = input.ID;
    this.activityID = input.activityID;
    this.userID = input.userID;
    this.score = input.score;

    return this;
  }

  getIsScoreFourSeven(): boolean {
    return this.score > (4 / 7) * 100;
  }
}

/**
 * 意識変容を問う質問の回答
 */
export class SurveyCompetencyAnswer {
  ID: number = 0;
  competencyID: number = 0;
  userID: number;
  score: number = 50;

  deserialize(input: any) {
    if (!input) return this;
    this.ID = input.ID;
    this.competencyID = input.competencyID;
    this.userID = input.userID;
    this.score = input.score;

    return this;
  }

  getIsScoreFourSeven(): boolean {
    return this.score > (4 / 7) * 100;
  }
}

/**
 * アクティブ回答のアクティビティ選択
 */
export class SurveyCompetencySelectActivity {
  ID: number = 0;
  activityID: number = 0;
  competencyID: number = 0;
  userID: number;

  deserialize(input: any) {
    if (!input) return this;
    this.activityID = input.activityID;
    this.competencyID = input.competencyID;
    this.userID = input.userID;

    return this;
  }
}

/**
 * 意識変容
 */
export class MetaAwarenessGrowthQuestion {
  ID: number = 0;
  competencyID: number = 0;
  questionText: string = '';

  deserialize(input: any) {
    if (!input) return this;
    this.ID = input.ID;
    this.competencyID = input.competencyID;
    this.questionText = input.questionText;

    return this;
  }
}

export class ActiveEntryMatrix {
  activityID: number = 0;
  competencyID: number = 0;
  underUnder: number = 0;
  underOver: number = 0;
  overUnder: number = 0;
  overOver: number = 0;
  availableTotal: number = 0;

  deserialize(input: any) {
    if (!input) return this;
    this.activityID = input.activityID;
    this.competencyID = input.competencyID;
    this.underUnder = input.underUnder;
    this.underOver = input.underOver;
    this.overUnder = input.overUnder;
    this.overOver = input.overOver;
    this.availableTotal = input.availableTotal;

    return this;
  }
}
